import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  main: {
    marginTop: 20,
    marginBottom: 10,
    width: '90%',
    alignItems: 'flex-end',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#dbdbdb'
  },
  titleContainer: {
    position: 'absolute',
    backgroundColor: '#ffffff',
    width: '100%',
    flexDirection: 'row-reverse',
    right: 0,
    top: -26
  },
  mainTitle: {
    fontSize: 10,
    marginRight: 3,
    backgroundColor: '000'
  },
  mainDiv: {
    width: '100%',
    marginVertical: 5,
    paddingRight: 10,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    paddingBottom: 5
  },
  line: {
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    fontSize: 9,
    color: '#6f6f89',
    fontWeight: 'bold'
  },
  word: {
    marginLeft: 3
  }
})

export default styles
